/* eslint-disable jsx-a11y/accessible-emoji */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./LandingPage.css";

import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useAssessment } from "../self-assesment2/assessmentState.js";
import { BrowserBlockScreen } from "../self-assesment2/SelfAssessmentUi.jsx";
import { Header } from "./Header.jsx";
import { Footer } from "./Footer.jsx";
import { StartMyra } from "./StartMyra.jsx";
import { LandingPageModal } from "../self-assesment2/LandingPageModal.jsx";
import { SEND_CONTACT_MESSAGE } from "../self-assesment2/GSA_CONSTANTS.js";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export const ContactUs = () => {
  ScrollToTop();
  const [formData, setFormData] = useState({ email: "", question: "" });
  const [showMemberBlockScreen, setShowMemberBlockScreen] = useState(false);
  const { setIsMyRAIsActive } = useAssessment();
  const [isMicModalActive, setIsMicModalActive] = useState(false);
  const [micModalMsg, setMicModalMsg] = useState("To chat with Myra, please grant microphone access. Your audio is processed in real-time and never stored or recorded.");
  const [access, setAccess] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // 'success' | 'error' | null
  const history = useHistory();

  const onGrant = () => {
    setIsMicModalActive(false);
    window.isUserChatWithMyra = true;
    if (window._myraPermissionCallbacks?.onGrant) window._myraPermissionCallbacks.onGrant();
  };

  const oncancel = () => {
    window.isStartedLandingFlow = false;
    window.isUserChatWithMyra = false;
    setAccess(false);
    setIsMyRAIsActive(false);
    setMicModalMsg("Mic access is needed for Myra to hear your questions. If you prefer not to allow mic access, you can select the Chat option next to Talk. Or, start the Guided Self-Assessment anytime without asking Myra questions.");
    if (window._myraPermissionCallbacks?.onCancel) window._myraPermissionCallbacks.onCancel();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const res = await fetch(SEND_CONTACT_MESSAGE, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (data.success) {
        setSubmitStatus("success");
        setFormData({ email: "", question: "" });
      } else {
        setSubmitStatus("error");
      }
    } catch (err) {
      console.error("Contact form error:", err);
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  const CalendarIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  );

  const EmailIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
      <polyline points="22,6 12,13 2,6" />
    </svg>
  );

  const QuestionIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
      <circle cx="12" cy="17" r="0.5" fill="currentColor" stroke="currentColor" strokeWidth="1" />
    </svg>
  );

  if (showMemberBlockScreen) return <BrowserBlockScreen featureType="member" />;

  return (
    <div className="contact-page">
      <Header setShowMemberBlockScreen={setShowMemberBlockScreen} onTryMyraClick={() => StartMyra(setIsMicModalActive, setIsMyRAIsActive)} />
      {isMicModalActive && <LandingPageModal message={micModalMsg} onGrant={onGrant} onCancel={oncancel} isMicModalActive={isMicModalActive} setIsMicModalActive={setIsMicModalActive} access={access} setAccess={setAccess} setMicModalMsg={setMicModalMsg} />}

      <div className="contact-page-wrapper">
        {/* ── LEFT COLUMN ── */}
        <div className="contact-left">
          <span className="contact-section-label">Connect</span>
          <h1 className="contact-heading">Let's Build Something Better Together</h1>
          <p className="contact-intro">Whether you're focused on improving workplace well-being or exploring a partnership, we're here to help. Reach out and let's shape the future of MSK recovery together.</p>

          {/* Schedule a Meeting */}
          <div className="contact-block">
            <div className="contact-block-header">
              <div className="contact-block-icon">
                <CalendarIcon />
              </div>
              <h3>Schedule a Meeting</h3>
            </div>
            <p className="contact-block-desc">Pick a time that works for you and we'll connect directly.</p>
            <a href="https://calendly.com/ty-bordner/30min" target="_blank" rel="noopener noreferrer" className="contact-btn-pill">
              Schedule a meeting now →
            </a>
          </div>

          {/* Email Us */}
          <div className="contact-block">
            <div className="contact-block-header">
              <div className="contact-block-icon">
                <EmailIcon />
              </div>
              <h3>Email Us</h3>
            </div>
            <p className="contact-block-desc">Prefer to reach out directly? Send us an email and we'll respond promptly.</p>
            <a href="mailto:info@virdio.com" className="contact-btn-pill">
              info@virdio.com →
            </a>
          </div>
        </div>

        {/* ── RIGHT COLUMN ── */}
        <div className="contact-right">
          <div className="contact-block">
            <div className="contact-block-header">
              <div className="contact-block-icon">
                <QuestionIcon />
              </div>
              <h3>Ask a Question</h3>
            </div>
            <p className="contact-block-desc">Enter your email and question below and we'll get back to you with an answer.</p>
            <div className="contact-form-card">
              <form onSubmit={handleSubmit}>
                <div className="form-group" style={{ marginBottom: "14px" }}>
                  <label htmlFor="q-email">Your email address</label>
                  <input type="email" id="q-email" name="email" placeholder="you@company.com" value={formData.email} onChange={handleChange} />
                </div>
                <div className="form-group" style={{ marginBottom: "14px" }}>
                  <label htmlFor="q-question">Your question</label>
                  <textarea id="q-question" name="question" placeholder="What would you like to know?" value={formData.question} onChange={handleChange} />
                </div>
                <button type="submit" className="submit-btn" disabled={isSubmitting}>
                  {isSubmitting ? "Sending..." : "Submit"}
                </button>

                {submitStatus === "success" && <p style={{ color: "green", marginTop: "10px", fontSize: "14px" }}>✅ Message sent! We'll get back to you soon.</p>}
                {submitStatus === "error" && <p style={{ color: "red", marginTop: "10px", fontSize: "14px" }}>❌ Something went wrong. Please try again.</p>}
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* <Footer /> */}
    </div>
  );
};
